import { css } from 'styled-components';
import PropTypes from 'prop-types';

/*
 ** Margin: ma, mb, mt, mr, ml, mx, my
 ** Padding: pa, pb, pt, pr, pl, px, py
 */
var sizes = {
  xxs: '8px',
  xs: '12px',
  sm: '16px',
  md: '24px',
  lg: '32px',
  xl: '40px',
  auto: 'auto',
  unset: 'unset'
};
var Spacing = css(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref) {
  var ma = _ref.ma;
  return ma && css(["margin:", ";"], sizes[ma]);
}, function (_ref2) {
  var mb = _ref2.mb;
  return mb && css(["margin-bottom:", ";"], sizes[mb]);
}, function (_ref3) {
  var mt = _ref3.mt;
  return mt && css(["margin-top:", ";"], sizes[mt]);
}, function (_ref4) {
  var ml = _ref4.ml;
  return ml && css(["margin-left:", ";"], sizes[ml]);
}, function (_ref5) {
  var mr = _ref5.mr;
  return mr && css(["margin-right:", ";"], sizes[mr]);
}, function (_ref6) {
  var mx = _ref6.mx;
  return mx && css(["margin-left:", ";margin-right:", ";"], sizes[mx], sizes[mx]);
}, function (_ref7) {
  var my = _ref7.my;
  return my && css(["margin-top:", ";margin-bottom:", ";"], sizes[my], sizes[my]);
}, function (_ref8) {
  var theme = _ref8.theme,
    maXs = _ref8['ma-xs'],
    mbXs = _ref8['mb-xs'],
    mtXs = _ref8['mt-xs'],
    mrXs = _ref8['mr-xs'],
    mlXs = _ref8['ml-xs'],
    mxXs = _ref8['mx-xs'],
    myXs = _ref8['my-xs'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", " ", " ", "}"], theme.breakpoint.xs, maXs && css(["margin:", ";"], sizes[maXs]), mbXs && css(["margin-bottom:", ";"], sizes[mbXs]), mtXs && css(["margin-top:", ";"], sizes[mtXs]), mlXs && css(["margin-left:", ";"], sizes[mlXs]), mrXs && css(["margin-right:", ";"], sizes[mrXs]), mxXs && css(["margin-left:", ";margin-right:", ";"], sizes[mxXs], sizes[mxXs]), myXs && css(["margin-top:", ";margin-bottom:", ";"], sizes[myXs], sizes[myXs]));
}, function (_ref9) {
  var theme = _ref9.theme,
    maSm = _ref9['ma-sm'],
    mbSm = _ref9['mb-sm'],
    mtSm = _ref9['mt-sm'],
    mrSm = _ref9['mr-sm'],
    mlSm = _ref9['ml-sm'],
    mxSm = _ref9['mx-sm'],
    mySm = _ref9['my-sm'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", " ", " ", "}"], theme.breakpoint.sm, maSm && css(["margin:", ";"], sizes[maSm]), mbSm && css(["margin-bottom:", ";"], sizes[mbSm]), mtSm && css(["margin-top:", ";"], sizes[mtSm]), mlSm && css(["margin-left:", ";"], sizes[mlSm]), mrSm && css(["margin-right:", ";"], sizes[mrSm]), mxSm && css(["margin-left:", ";margin-right:", ";"], sizes[mxSm], sizes[mxSm]), mySm && css(["margin-top:", ";margin-bottom:", ";"], sizes[mySm], sizes[mySm]));
}, function (_ref10) {
  var theme = _ref10.theme,
    maMd = _ref10['ma-md'],
    mbMd = _ref10['mb-md'],
    mtMd = _ref10['mt-md'],
    mrMd = _ref10['mr-md'],
    mlMd = _ref10['ml-md'],
    mxMd = _ref10['mx-md'],
    myMd = _ref10['my-md'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", " ", " ", "}"], theme.breakpoint.md, maMd && css(["margin:", ";"], sizes[maMd]), mbMd && css(["margin-bottom:", ";"], sizes[mbMd]), mtMd && css(["margin-top:", ";"], sizes[mtMd]), mlMd && css(["margin-left:", ";"], sizes[mlMd]), mrMd && css(["margin-right:", ";"], sizes[mrMd]), mxMd && css(["margin-left:", ";margin-right:", ";"], sizes[mxMd], sizes[mxMd]), myMd && css(["margin-top:", ";margin-bottom:", ";"], sizes[myMd], sizes[myMd]));
}, function (_ref11) {
  var theme = _ref11.theme,
    maLg = _ref11['ma-lg'],
    mbLg = _ref11['mb-lg'],
    mtLg = _ref11['mt-lg'],
    mrLg = _ref11['mr-lg'],
    mlLg = _ref11['ml-lg'],
    mxLg = _ref11['mx-lg'],
    myLg = _ref11['my-lg'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", " ", " ", "}"], theme.breakpoint.lg, maLg && css(["margin:", ";"], sizes[maLg]), mbLg && css(["margin-bottom:", ";"], sizes[mbLg]), mtLg && css(["margin-top:", ";"], sizes[mtLg]), mlLg && css(["margin-left:", ";"], sizes[mlLg]), mrLg && css(["margin-right:", ";"], sizes[mrLg]), mxLg && css(["margin-left:", ";margin-right:", ";"], sizes[mxLg], sizes[mxLg]), myLg && css(["margin-top:", ";margin-bottom:", ";"], sizes[myLg], sizes[myLg]));
}, function (_ref12) {
  var pa = _ref12.pa;
  return pa && css(["padding:", ";"], sizes[pa]);
}, function (_ref13) {
  var pb = _ref13.pb;
  return pb && css(["padding-bottom:", ";"], sizes[pb]);
}, function (_ref14) {
  var pt = _ref14.pt;
  return pt && css(["padding-top:", ";"], sizes[pt]);
}, function (_ref15) {
  var pl = _ref15.pl;
  return pl && css(["padding-left:", ";"], sizes[pl]);
}, function (_ref16) {
  var pr = _ref16.pr;
  return pr && css(["padding-right:", ";"], sizes[pr]);
}, function (_ref17) {
  var px = _ref17.px;
  return px && css(["padding-left:", ";padding-right:", ";"], sizes[px], sizes[px]);
}, function (_ref18) {
  var py = _ref18.py;
  return py && css(["padding-top:", ";padding-bottom:", ";"], sizes[py], sizes[py]);
}, function (_ref19) {
  var theme = _ref19.theme,
    paXs = _ref19['pa-xs'],
    pbXs = _ref19['pb-xs'],
    ptXs = _ref19['pt-xs'],
    prXs = _ref19['pr-xs'],
    plXs = _ref19['pl-xs'],
    pxXs = _ref19['px-xs'],
    pyXs = _ref19['py-xs'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", " ", " ", "}"], theme.breakpoint.xs, paXs && css(["padding:", ";"], sizes[paXs]), pbXs && css(["padding-bottom:", ";"], sizes[pbXs]), ptXs && css(["padding-top:", ";"], sizes[ptXs]), plXs && css(["padding-left:", ";"], sizes[plXs]), prXs && css(["padding-right:", ";"], sizes[prXs]), pxXs && css(["padding-left:", ";padding-right:", ";"], sizes[pxXs], sizes[pxXs]), pyXs && css(["padding-top:", ";padding-bottom:", ";"], sizes[pyXs], sizes[pyXs]));
}, function (_ref20) {
  var theme = _ref20.theme,
    paSm = _ref20['pa-sm'],
    pbSm = _ref20['pb-sm'],
    ptSm = _ref20['pt-sm'],
    prSm = _ref20['pr-sm'],
    plSm = _ref20['pl-sm'],
    pxSm = _ref20['px-sm'],
    pySm = _ref20['py-sm'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", " ", " ", "}"], theme.breakpoint.sm, paSm && css(["padding:", ";"], sizes[paSm]), pbSm && css(["padding-bottom:", ";"], sizes[pbSm]), ptSm && css(["padding-top:", ";"], sizes[ptSm]), plSm && css(["padding-left:", ";"], sizes[plSm]), prSm && css(["padding-right:", ";"], sizes[prSm]), pxSm && css(["padding-left:", ";padding-right:", ";"], sizes[pxSm], sizes[pxSm]), pySm && css(["padding-top:", ";padding-bottom:", ";"], sizes[pySm], sizes[pySm]));
}, function (_ref21) {
  var theme = _ref21.theme,
    paMd = _ref21['pa-md'],
    pbMd = _ref21['pb-md'],
    ptMd = _ref21['pt-md'],
    prMd = _ref21['pr-md'],
    plMd = _ref21['pl-md'],
    pxMd = _ref21['px-md'],
    pyMd = _ref21['py-md'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", " ", " ", "}"], theme.breakpoint.md, paMd && css(["padding:", ";"], sizes[paMd]), pbMd && css(["padding-bottom:", ";"], sizes[pbMd]), ptMd && css(["padding-top:", ";"], sizes[ptMd]), plMd && css(["padding-left:", ";"], sizes[plMd]), prMd && css(["padding-right:", ";"], sizes[prMd]), pxMd && css(["padding-left:", ";padding-right:", ";"], sizes[pxMd], sizes[pxMd]), pyMd && css(["padding-top:", ";padding-bottom:", ";"], sizes[pyMd], sizes[pyMd]));
}, function (_ref22) {
  var theme = _ref22.theme,
    paLg = _ref22['pa-lg'],
    pbLg = _ref22['pb-lg'],
    ptLg = _ref22['pt-lg'],
    prLg = _ref22['pr-lg'],
    plLg = _ref22['pl-lg'],
    pxLg = _ref22['px-lg'],
    pyLg = _ref22['py-lg'];
  return css(["   @media (min-width:", "){", " ", " ", " ", " ", " ", " ", "}"], theme.breakpoint.lg, paLg && css(["padding:", ";"], sizes[paLg]), pbLg && css(["padding-bottom:", ";"], sizes[pbLg]), ptLg && css(["padding-top:", ";"], sizes[ptLg]), plLg && css(["padding-left:", ";"], sizes[plLg]), prLg && css(["padding-right:", ";"], sizes[prLg]), pxLg && css(["padding-left:", ";padding-right:", ";"], sizes[pxLg], sizes[pxLg]), pyLg && css(["padding-top:", ";padding-bottom:", ";"], sizes[pyLg], sizes[pyLg]));
});
var spacingTypes = ['auto', 'xs', 'xxs', 'sm', 'md', 'lg', 'xl', 'unset'];
var SpacingPropTypes = {
  ma: PropTypes.oneOf(spacingTypes),
  mb: PropTypes.oneOf(spacingTypes),
  mt: PropTypes.oneOf(spacingTypes),
  mr: PropTypes.oneOf(spacingTypes),
  ml: PropTypes.oneOf(spacingTypes),
  mx: PropTypes.oneOf(spacingTypes),
  my: PropTypes.oneOf(spacingTypes),
  pa: PropTypes.oneOf(spacingTypes),
  pb: PropTypes.oneOf(spacingTypes),
  pt: PropTypes.oneOf(spacingTypes),
  pr: PropTypes.oneOf(spacingTypes),
  pl: PropTypes.oneOf(spacingTypes),
  px: PropTypes.oneOf(spacingTypes),
  py: PropTypes.oneOf(spacingTypes),
  'ma-xs': PropTypes.oneOf(spacingTypes),
  'mb-xs': PropTypes.oneOf(spacingTypes),
  'mt-xs': PropTypes.oneOf(spacingTypes),
  'mr-xs': PropTypes.oneOf(spacingTypes),
  'ml-xs': PropTypes.oneOf(spacingTypes),
  'mx-xs': PropTypes.oneOf(spacingTypes),
  'my-xs': PropTypes.oneOf(spacingTypes),
  'pa-xs': PropTypes.oneOf(spacingTypes),
  'pb-xs': PropTypes.oneOf(spacingTypes),
  'pt-xs': PropTypes.oneOf(spacingTypes),
  'pr-xs': PropTypes.oneOf(spacingTypes),
  'pl-xs': PropTypes.oneOf(spacingTypes),
  'px-xs': PropTypes.oneOf(spacingTypes),
  'py-xs': PropTypes.oneOf(spacingTypes),
  'ma-sm': PropTypes.oneOf(spacingTypes),
  'mb-sm': PropTypes.oneOf(spacingTypes),
  'mt-sm': PropTypes.oneOf(spacingTypes),
  'mr-sm': PropTypes.oneOf(spacingTypes),
  'ml-sm': PropTypes.oneOf(spacingTypes),
  'mx-sm': PropTypes.oneOf(spacingTypes),
  'my-sm': PropTypes.oneOf(spacingTypes),
  'pa-sm': PropTypes.oneOf(spacingTypes),
  'pb-sm': PropTypes.oneOf(spacingTypes),
  'pt-sm': PropTypes.oneOf(spacingTypes),
  'pr-sm': PropTypes.oneOf(spacingTypes),
  'pl-sm': PropTypes.oneOf(spacingTypes),
  'px-sm': PropTypes.oneOf(spacingTypes),
  'py-sm': PropTypes.oneOf(spacingTypes),
  'ma-md': PropTypes.oneOf(spacingTypes),
  'mb-md': PropTypes.oneOf(spacingTypes),
  'mt-md': PropTypes.oneOf(spacingTypes),
  'mr-md': PropTypes.oneOf(spacingTypes),
  'ml-md': PropTypes.oneOf(spacingTypes),
  'mx-md': PropTypes.oneOf(spacingTypes),
  'my-md': PropTypes.oneOf(spacingTypes),
  'pa-md': PropTypes.oneOf(spacingTypes),
  'pb-md': PropTypes.oneOf(spacingTypes),
  'pt-md': PropTypes.oneOf(spacingTypes),
  'pr-md': PropTypes.oneOf(spacingTypes),
  'pl-md': PropTypes.oneOf(spacingTypes),
  'px-md': PropTypes.oneOf(spacingTypes),
  'py-md': PropTypes.oneOf(spacingTypes),
  'ma-lg': PropTypes.oneOf(spacingTypes),
  'mb-lg': PropTypes.oneOf(spacingTypes),
  'mt-lg': PropTypes.oneOf(spacingTypes),
  'mr-lg': PropTypes.oneOf(spacingTypes),
  'ml-lg': PropTypes.oneOf(spacingTypes),
  'mx-lg': PropTypes.oneOf(spacingTypes),
  'my-lg': PropTypes.oneOf(spacingTypes),
  'pa-lg': PropTypes.oneOf(spacingTypes),
  'pb-lg': PropTypes.oneOf(spacingTypes),
  'pt-lg': PropTypes.oneOf(spacingTypes),
  'pr-lg': PropTypes.oneOf(spacingTypes),
  'pl-lg': PropTypes.oneOf(spacingTypes),
  'px-lg': PropTypes.oneOf(spacingTypes),
  'py-lg': PropTypes.oneOf(spacingTypes)
};
export { Spacing, SpacingPropTypes };